import defaultOptions from './options'

// Merges default options and plugin options
export function updateOptions (params) {
  return Object.assign(defaultOptions, params)
}
